import React, { FC } from 'react';
import { Col, FormGroup, FormLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import DateTime from '../../../../../../components/library/inputs/dateTime/DateTime';

interface Props {
  label: string;
  value: string | undefined;
  onChange: (event: string) => void;
  mode: 'birthdate' | 'date' | 'datetime' | 'time';
  size?: number;
}

const DateSetting: FC<Props> = ({ label, value, onChange, mode, size = 12 }: Props) => {
  return (
    <FormGroup className={'form-group'} as={Col} md={size}>
      <FormLabel>
        <FormattedMessage id={label} />
      </FormLabel>
      <DateTime
        enabled={true}
        placeholder={undefined}
        value={value}
        touched={false}
        error={''}
        mode={mode}
        onChange={onChange}
      />
    </FormGroup>
  );
};

export default DateSetting;
